module.exports = __webpack_public_path__ + "static/media/Klymit-Web-Destop-blog2.d7b78ed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Klymit/Klymit-Web-Destop-blog2.jpg
// module id = 599
// module chunks = 0